<script setup lang="ts">
import { isFirefox, isOpera } from 'mobile-device-detect'
import SeperatorImg from '@/assets/components/categoryOffersBlock/separator.webp?url'
import {
  canInstallAsApp,
  checkBoxDisableInstallPrompt,
  disableInstallPrompt,
  openInstallPrompt,
  showConfirmDisableInstallPrompt,
  supportedInstallAsApp
} from '@/components/layout/InstallPromptComponent/InstallPromptCompose'

const { routeGame } = gamesUtils
const { t } = useI18n()
// shown to all visitors (logged in or not) - the footer install button is the logged-in-only one
const isVisible = computed(() => {
  return !(
    isOpera ||
    isFirefox ||
    import.meta.env.SSR ||
      disableInstallPrompt.value ||
      (supportedInstallAsApp.value && !canInstallAsApp.value)
  )
})
function disable() {
  if (checkBoxDisableInstallPrompt.value) {
    disableInstallPrompt.value = true
  }
}
function onAdd() {
  openInstallPrompt('installBtn', routeGame.value?.gameKey)
}

function showConfirmBtn() {
  showConfirmDisableInstallPrompt.value = true
  setTimeout(() => {
    checkBoxDisableInstallPrompt.value = false
    showConfirmDisableInstallPrompt.value = false
  }, 15000)
}
</script>

<template>
  <transition name="el-fade-in-linear">
    <div
      v-if="isVisible"
      class="relative  w-full m-auto"
    >
      <img
        alt=""
        class="w-full absolute lef-0 right-0 -translate-y-1/2 z-10"
        :src="SeperatorImg"
      >
      <div

        class="text-center relative bg-[#2b7989] pt-3  pb-3 sm:pt-10 sm:pb-6  text-white px-1 sm:px-4 2xl:py-20"
      >
        <div class="inline group">
          <el-button
            link
            class="text-xl font-extrabold hover:text-neutral-100 text-white mt-1"
            @click="onAdd"
          >
            <div class="flex items-center">
              <icon-ify
                icon="material-symbols:add-box-outline"
                class="inline-block text-[1.5em] 2xl:text-[2.2em] translate-y-0.5 mr-1"
              />
              <span class="underline underline-offset-4 2xl:text-[1.3em]">{{ t('footer.addToHomeScreen') }}</span>
            </div>
          </el-button>
          <div
            class="flex justify-center w-full min-h-11 big:min-h-9 items-center mb-1.5 big:mb-0"
          >
            <button
              v-if="showConfirmDisableInstallPrompt"
              class="text-sm font-bold border border-white rounded-lg px-4 py-1 leading-5 -translate-y-1"
              @click="disable"
            >
              {{ t('installPrompt.confirmHiding') }}
            </button>
            <el-checkbox
              v-show="!checkBoxDisableInstallPrompt"
              v-model="checkBoxDisableInstallPrompt"
              :label="t('installPrompt.dontShowAgain')"
              class="big:invisible group-hover:visible text-xl mx-auto text-white -translate-y-1"
              size="large"
              @change="showConfirmBtn"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped lang="postcss"></style>
